const stations = [
  {
    coordinate: { latitude: -16.40644722, longitude: -71.40938889 },
    title: 'Chiguata',
    key: 'chiguata',
  },
  {
    coordinate: { latitude: -16.41384167, longitude: -71.53451944 },
    title: 'LaPampilla',
    key: 'laPampilla',
  },
  {
    coordinate: { latitude: -16.457742, longitude: -71.566347 },
    title: 'Huasacache',
    key: 'huasacache',
  },
  {
    coordinate: { latitude: -16.33565278, longitude: -72.15265556 },
    title: 'Pampa de Majes',
    key: 'pampaDeMajes',
  },
  {
    coordinate: { latitude: -15.64163611, longitude: -71.60173056 },
    title: 'Chivay',
    key: 'chivay',
  },
  {
    coordinate: { latitude: -15.60998889, longitude: -71.80654444 },
    title: 'Madrigal',
    key: 'madrigal',
  },
  {
    coordinate: { latitude: -15.622594, longitude: -71.974086 },
    title: 'Cabanaconde',
    key: 'cabanaconde',
  },
];

export default function getStations() {
  return stations;
}
